import { request, RequestError, RequestErrorType } from '@tencent/vft-common/request'
import env from '@tencent/vft-common/env'

export async function getAd () {
  return request('//vip.video.qq.com/fcgi-bin/comm_cgi?name=spp_VipActConf_V2&cmd=2&posId=16', {
    platform: env.isIos ? 7 : 8
  }, {
    dataType: 'jsonp',
    xhrFields: {
      withCredentials: true
    }
  }).then(res => {
    if (!res) {
      throw new RequestError(-2, '网络开了小差，请重试', res, RequestErrorType.SYSTEM_ERR)
    }
    if (!res.posList || !res.posList[0] || res.posList[0].code !== 0 || !res.posList[0].confData || !res.posList[0].confData[0]) {
      throw new RequestError(res.code, res.msg || '未知错误', res, RequestErrorType.LOGIC_ERR)
    }
    return res.posList[0].confData[0]
  })
}
